import * as React from 'react';
import Project from 'src/entities/Project';
import Modal from 'src/modules/commons/modal-handler/jQueryModal';
import '../../Modals.css';
import './RawAmountInvestment.css';
import InvestmentFunnelHeaderComponent
  from 'src/modules/modals/investment-funnel/partials/InvestmentFunnelHeader.component';

export interface RawAmountInvestmentComponentProps {
  project: Project;
  modalRef?: Modal;
}

class RawAmountInvestmentComponent extends React.PureComponent<RawAmountInvestmentComponentProps> {

  public render(): React.ReactNode {

    return (
      <div className="modal-content raw-amount-investment-modal">
        <InvestmentFunnelHeaderComponent
          logo={this.props.project.company.logo}
          modalRef={this.props.modalRef}
        />
        <div className="modal-body">
          <p className="title">
            El importe comprometido en <strong>{this.props.project.company.name}</strong> no coincide con el número de
            tickets, por favor contacta con <strong>
            <a href="mailto:investors@thecrowdangel.com">investors@thecrowdangel.com</a>
          </strong> para poder añadir más tickets a tu compromiso de inversión.
          </p>
        </div>
      </div>
    );
  }
}

export default RawAmountInvestmentComponent;



// WEBPACK FOOTER //
// ./src/modules/modals/investment-funnel/raw-amount-investment/RawAmountInvestment.component.tsx